export const CAMPAIGN_AI_GUIDELINES_DISMISSED_KEY =
  'autoclipper:cpm-ai-guidelines:dismissed';

const CAMPAIGN_AI_GUIDELINES_SEEN_PREFIX =
  'autoclipper:cpm-ai-guidelines:seen:';

export function campaignAiGuidelinesSeenKey(campaignId: string): string {
  return `${CAMPAIGN_AI_GUIDELINES_SEEN_PREFIX}${campaignId}`;
}

export function getCampaignAiGuidelinesStorage(
  browser: object,
): Storage | null {
  try {
    return (browser as { readonly localStorage?: Storage }).localStorage ?? null;
  } catch {
    return null;
  }
}

export function shouldShowCampaignAiGuidelines(
  storage: Pick<Storage, 'getItem'> | null,
  campaignId: string,
): boolean {
  if (!storage) return true;

  try {
    return !storage.getItem(CAMPAIGN_AI_GUIDELINES_DISMISSED_KEY)
      && !storage.getItem(campaignAiGuidelinesSeenKey(campaignId));
  } catch {
    return true;
  }
}

export function recordCampaignAiGuidelinesAcknowledgement(
  storage: Pick<Storage, 'setItem'> | null,
  campaignId: string,
  dismissAll: boolean,
): void {
  if (!storage) return;

  try {
    storage.setItem(campaignAiGuidelinesSeenKey(campaignId), '1');
    if (dismissAll) {
      storage.setItem(CAMPAIGN_AI_GUIDELINES_DISMISSED_KEY, '1');
    }
  } catch {
    // Educational persistence must never block campaign access.
  }
}
